import Keycloak from "keycloak-js";
import { getConfig } from "../config";

let _keycloak = null;

export function getKeycloak() {
  if (!_keycloak) {
    const cfg = getConfig();
    _keycloak = new Keycloak({
      url: cfg.keycloak.url,
      realm: cfg.keycloak.realm,
      clientId: cfg.keycloak.clientId,
    });
  }
  return _keycloak;
}